import { useState } from "react";
import { AuthProvider } from "@pravaler/amigoedu-ui/dist/components/Auth";
import { Footer } from "@pravaler/amigoedu-ui/dist/components/Footer";
import Cookies from "js-cookie";

import { WHATSSAPP_NUMBER } from "@constants/whatsAppMessages";
import { cookies } from "@constants/cookies";
import { getUtms } from "@utils/utms";
import { useMedia } from "hooks/useMedia";
import { Header } from "@components/Header";
import { useRouter } from "next/router";
import SignModal from "@components/SignModal";
import { storage } from "@utils/storage";
import { ContactModal } from "@components/ContactModal";
import dynamic from "next/dynamic";

const GOOGLE_CLIENT_ID = process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID!;
const FACEBOOK_APP_ID = process.env.NEXT_PUBLIC_FACEBOOK_APP_ID!;
const RECAPTCHA_SITE_KEY = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY!;
const ENDPOINT_URL = process.env.NEXT_PUBLIC_API_URL!;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const AuthStep = dynamic<any>(() => import("@pravaler/amigoedu-ui/dist/components/Auth/AuthStep").then((mod) => mod.AuthStep));

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const AuthHeader = dynamic<any>(() => import("@pravaler/amigoedu-ui/dist/components/Auth/AuthHeader").then((mod) => mod.AuthHeader));

const Layout = ({ children }): JSX.Element => {
	const [showModal, setShowModal] = useState(false);
	const [fixed, setFixed] = useState(false);
	const [fixHeader, setFixHeader] = useState(false);
	const [showSign, setShowSign] = useState(false);
	const [showContactModal, setShowContactModal] = useState(false);
	const [amigoPravalerHeader, setAmigoPravalerHeader] = useState(false);
	const [transparentHeader, setTransparentHeader] = useState(false);
	const [dontShowHeader, setDontShowHeader] = useState(false);
	const [isMounted, setMounted] = useState(false);
	const [state, setState] = useState({
		showModal: false,
		showSign: false,
		fixed: false,
		fixHeader: false,
		showContactModal: false,
		amigoPravalerHeader: false,
		transparentHeader: false,
		dontShowHeader: false,
		isMounted: false,
	});
	const isMobile = useMedia(["(max-width: 576px)"], [true], false);
	const location = useRouter();
	const closeModalDisable = typeof window !== "undefined" && window.location.pathname.includes("/registro");
	const basicMode = !!(location.pathname.match(/enae\.*/) || location.pathname.match(/concurso-bolsas/));
	let customHeader: "estacio" | "ibmec" | "doctum" | null | undefined; // Verificar para que serve o customHeader
	const referralCoupomFromCookies = Cookies.get(cookies.COOKIES_REFERRAL_COUPON);

	const getIsLoggedIn = () => !!storage.getItem("user" || "");
	const isLoggedIn = !!storage.getItem("user" || "");

	return (
		<AuthProvider
			isMobile={isMobile}
			isOpen={showModal}
			toggleModal={closeModalDisable ? () => setShowModal(true) : setShowModal}
			onBottomSheetDismiss={() => setShowModal(false)}
			facebookAppId={FACEBOOK_APP_ID}
			recaptchaKey={RECAPTCHA_SITE_KEY}
			googleClientId={GOOGLE_CLIENT_ID}
			endpointUrl={ENDPOINT_URL}
			// opcionais
			utmData={getUtms()}
			referralCoupon={referralCoupomFromCookies}
			AuthHeader={() => <AuthHeader isMobile={isMobile} />}
			AuthStep={() => <AuthStep />}
		>
			<>
				<Header
					onClickShowModal={setShowModal}
					isLoggedIn={isLoggedIn}
					onLogout={getIsLoggedIn}
					setShowSignInForm={setShowSign}
					setFixed={setFixed}
					setShowContact={setShowContactModal}
					fixHeader={fixHeader}
					basicMode={basicMode}
					amigoPravaler={amigoPravalerHeader}
					transparent={transparentHeader}
					dontShowHeader={dontShowHeader}
					customHeader={customHeader}
				/>
				<main>{children}</main>
				<SignModal onLogin={getIsLoggedIn} />
				<ContactModal setModalVisible={setShowContactModal} visible={showContactModal} />
				<Footer isBlog />
			</>
		</AuthProvider>
	);
};

export default Layout;
